// Core
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
// components

// Styles
import './styles.scss';

// Assets
import { message } from 'antd';

import { restAPIs } from 'utils/restAPIs';
import { fetchData } from 'utils/fetch';
import ChangePassword from 'components/modals/ChangePassword';
import ChangeName from 'components/modals/ChangeName';
import ChangeEmail from 'components/modals/ChangeEmail';
import AddInvitation from 'components/modals/AddInvitation';
import DeleteAccount from 'components/modals/DeleteAccount';
import Unsubscribe from 'components/modals/Unsubscribe';
import { useRef } from 'react';
import { APP_ID } from 'config/constants';
import { CameraOutlined, CheckCircleFilled, ContainerOutlined, DeleteOutlined, EditOutlined, EllipsisOutlined, HeartOutlined, HistoryOutlined, LogoutOutlined, MailOutlined, RedoOutlined, SwitcherOutlined, TranslationOutlined, WalletOutlined } from '@ant-design/icons';
import RestoreAccount from 'components/modals/RestoreAccount';
import LogOut from 'components/modals/LogOut';
import { Fade } from 'react-reveal';
import { getStoredToken, updateStoredUser } from 'utils/auth';

const Settings = () => {
    const { userDetails, currentLang } = useSelector((store) => store.commonData);
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const [show, setShow] = useState(false);
    const [openLogOut, setLogOutOpen] = useState(false);
    const [openRestoreAccount, setOpenRestoreAccount] = useState(false);
    const [openDeleteAccount, setOpenDeleteAccount] = useState(false);
    const [openPswd, setOpenPaswd] = useState(false);
    const [openName, setOpenName] = useState(false);
    const [openEmail, setOpenEmail] = useState(false);
    const [openInvitation, setOpenInvitation] = useState(false)
    const [changeImg, setChangeImage] = useState({});
    const hiddenChangeImg = useRef(null);
    const [expiryDate, setExpiryDate] = useState('')

    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        transformDate();
    }, [userDetails?.expiryDate]);

    const handleOpenChangePaswd = () => {
        setOpenPaswd(true);
    };

    const handleClosePaswd = (value) => {
        setOpenPaswd(false);
    };

    const handleOpenChangeName = () => {
        setOpenName(true);
    };
    const handleCloseName = () => {
        setOpenName(false);
    };

    const handleOpenChangeEmail = () => {
        setOpenEmail(true);
    };
    const handleCloseEmail = () => {
        setOpenEmail(false);
    };

    const handleOpenDeleteAccount = () => {
        setOpenDeleteAccount(true);
    };
    const handleCloseDeleteAccount = () => {
        setOpenDeleteAccount(false);
    };

    const handleOpenRestoreAccount = () => {
        setOpenRestoreAccount(true);
    };

    const handleCloseRestoreAccount = () => {
        setOpenRestoreAccount(false);
    };

    const handleOpenInvitation = () => {
        setOpenInvitation(true);
    };

    const handleCloseInvitation = (value) => {
        setOpenInvitation(false);
    };

    const openUnsubscribe = () => {
        setShow(true);
    };

    const closeUnsubscribe = (value) => {
        setShow(false);
    };

    const handleProfileInput = (file) => {
        let files = file.target.files
        const reader = new FileReader();
        if (files.item(0)) {
            reader.readAsDataURL(files.item(0));
            reader.onload = (_event) => {
                setChangeImage({ img: reader.result, file: files.item(0) })
            }
        }
    }

    const handleOpenChangePicture = event => {
        hiddenChangeImg.current.click();
    };

    const changeProfilePic = async () => {
        const formData = new FormData();
        formData.append('profile_pic', changeImg.file)
        formData.append('appid', APP_ID)
        const res = await fetchData(restAPIs.changeProfPic(formData));
        if (res.statusCode === 200) {
            messageApi.open({
                type: 'success',
                content: res.errormessage,
            });
            // Previously saved the stale userDetails, so the new picture was lost on reload.
            updateStoredUser(dispatch, { profile_pic: res.profile_pic + '&' + Math.random() });
            setChangeImage({})

        } else {
            messageApi.open({
                type: 'error',
                content: res.errormessage,
            });
        }
    }

    const handleChangeLang = async (value) => {
        if (value === currentLang?.lang) return;
        i18n.changeLanguage(value);
        dispatch({
            type: 'currentLang',
            value: { lang: value, id: value === 'ar' ? 1 : 2 }
        });
        if (value === 'ar') {
            document.body.classList.add('arabic');
        }
        else {
            document.body.classList.remove('arabic')
        }
        if (getStoredToken()) {
            const formData = new FormData();
            formData.append('language', value);
            formData.append('appId', APP_ID);
            const res = await fetchData(restAPIs.changeLanguage(formData));
            if (res.statusCode === 200) {
                dispatch({
                    type: 'userDetails',
                    value: { ...userDetails, language: res.language }
                });
            }
        }
    };

    const transformDate = () => {
        if (!userDetails?.expiryDate) {
            setExpiryDate('')
            return
        }
        const currentDate = new Date(userDetails.expiryDate)
        if (Number.isNaN(currentDate.getTime())) {
            setExpiryDate('')
            return
        }
        const monthNames = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
          ];

        const day = currentDate.getDate();
        const month = currentDate.getMonth(); // Month is zero-based, so add 1
        const year = currentDate.getFullYear();
        const formattedDate = `${day} ${monthNames[month]}, ${year}`;
        setExpiryDate(formattedDate)

    }


    return (
        <>
            <div className='container __innerTopPad' dir={currentLang?.id === 1 ? 'rtl' : 'ltr'}>
                <h3 className='__common-head'> {t('settings')}</h3>
                {contextHolder}

                <div className="__acc_layout">
                    <Fade bottom cascade>
                        <div className="__acc_card __acc_profile">
                            <div className="prfImg">
                                {changeImg?.img ?
                                    <img src={changeImg?.img} alt={userDetails?.username} />
                                    :
                                    <img src={userDetails?.profile_pic} alt={userDetails?.username} />
                                }
                                {changeImg?.img && <a className='savePic' onClick={changeProfilePic}><CheckCircleFilled /></a>}
                            </div>
                            <h3>{userDetails?.username}</h3>
                            <p className='__acc_subtext'>{userDetails?.email}</p>
                            {userDetails && userDetails?.isPremium ?
                                <>
                                    <button className='___subscriptioName'>{userDetails?.subscriptionName}</button>
                                    <p className='__acc_subtext'>Expires on: {expiryDate}</p>
                                </>
                                : ''
                            }
                            <input type="file" onChange={handleProfileInput} ref={hiddenChangeImg} style={{ display: 'none' }} />
                        </div>
                    </Fade>

                    <Fade bottom cascade>
                        <div className="__acc_card __acc_list">
                            <h6>{t('my_account')}</h6>
                            <div className='__acc_grid'>
                                <a className='__acc_tile' onClick={handleOpenChangeName}><EditOutlined />{t('change_name')}</a>
                                <a className='__acc_tile' onClick={handleOpenChangePicture}><CameraOutlined />{t('edit_picture')}</a>
                                <a className='__acc_tile' onClick={handleOpenChangeEmail}><MailOutlined />{t('change_email')}</a>
                                <a className='__acc_tile' onClick={handleOpenChangePaswd}><EllipsisOutlined />{t('change_password')}</a>
                                <NavLink className='__acc_tile' to={'/favourites'} end><HeartOutlined />{t('favourites')}</NavLink>
                                <NavLink className='__acc_tile' to={'/refer-and-earn'} end><WalletOutlined />{t('my_wallet')}</NavLink>
                                {userDetails && !userDetails?.isPremium && <a className='__acc_tile' onClick={handleOpenInvitation}><ContainerOutlined />{t('add_invitation_key')}</a>}
                                {userDetails && !userDetails?.isPremium ?
                                    <NavLink className='__acc_tile' to={'/subscribe'} end><SwitcherOutlined />{t('subscribe')}</NavLink> :
                                    <a className='__acc_tile' onClick={openUnsubscribe}><RedoOutlined />Unsubscribe</a>
                                }
                            </div>

                            <div className='__acc_lang_row'>
                                <span><TranslationOutlined />{t('change_language')}</span>
                                <div className='__acc_lang_toggle'>
                                    <button className={currentLang?.lang === 'ar' ? 'active' : ''} onClick={() => handleChangeLang('ar')}>عربي</button>
                                    <button className={currentLang?.lang !== 'ar' ? 'active' : ''} onClick={() => handleChangeLang('en')}>ENG</button>
                                </div>
                            </div>

                            <div className='__acc_danger_row'>
                                {
                                    userDetails && (userDetails.markDeletion == 0) ?
                                        <a className='__acc_danger' onClick={handleOpenDeleteAccount}><DeleteOutlined />{t('delete_account')}</a> :
                                        <a className='__acc_danger' onClick={handleOpenRestoreAccount}><HistoryOutlined />{t('restore_account')}</a>
                                }
                                <a className='__acc_danger' onClick={() => setLogOutOpen(true)}><LogoutOutlined />{t('sign_out')}</a>
                            </div>
                        </div>
                    </Fade>
                </div>

                <ChangePassword open={openPswd} onClose={handleClosePaswd} />
                <ChangeName open={openName} onClose={handleCloseName} />
                <ChangeEmail open={openEmail} onClose={handleCloseEmail} />
                <AddInvitation open={openInvitation} onClose={handleCloseInvitation} />
                <DeleteAccount open={openDeleteAccount} onClose={handleCloseDeleteAccount} />
                <RestoreAccount open={openRestoreAccount} onClose={handleCloseRestoreAccount} />
                <Unsubscribe open={show} onClose={closeUnsubscribe} />
                <LogOut open={openLogOut} onClose={() => setLogOutOpen(false)} />
            </div>
        </>
    );
};


export default Settings;
